import { render } from "./PublishToGalleryDialog.vue?vue&type=template&id=4661e8fa&scoped=true"
import script from "./PublishToGalleryDialog.vue?vue&type=script&lang=ts"
export * from "./PublishToGalleryDialog.vue?vue&type=script&lang=ts"

import "./PublishToGalleryDialog.vue?vue&type=style&index=0&id=4661e8fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4661e8fa"

export default script